import { Flex, Icon } from '@cad-arc';
import { CARD_BUTTON_SECTION_WIDTH } from '../../../constants';
import { useGoToDexPageWithEntityPrefilled } from '../hooks';
import { Entity, EntityTypes, MergedEntityTypes } from '../../../../../fr-entity-panels/types';

export function DexDetailsRedirectionButton({
    entity,
    entityType,
}: {
    entity: Entity;
    entityType: EntityTypes | MergedEntityTypes;
}) {
    const goToDexPageWithEntityPrefilled = useGoToDexPageWithEntityPrefilled({
        entity,
        entityType,
    });

    return (
        <Flex
            data-testid="dex-details-redirection-button"
            minWidth={CARD_BUTTON_SECTION_WIDTH}
            maxWidth={CARD_BUTTON_SECTION_WIDTH}
            height="100%"
            alignItems="center"
            justifyContent="center"
            borderLeftWidth="1px"
            borderLeftColor="border.default"
            onClick={goToDexPageWithEntityPrefilled}
            role="button"
            _hover={{
                backgroundColor: 'surface.accent',
                cursor: 'pointer',
            }}
        >
            <Icon role="button" icon="DataExchangeInquiries" color="brand.default" />
        </Flex>
    );
}
